import React from 'react';

import { formatNumberToHours } from 'utils/datetime';

import styles from './styles.module.css';

const TimeScale = ({ isLastLabel = false, isFirstColumn = true }) => {
	const hours = [];
	for (let i = 0; i < 25; i++) {
		const shouldShowLabel = i % 4 === 0;
		const isFirst = i === 0;
		const isLast = isLastLabel && i === 24;
		const showFirstLine = isFirst && isFirstColumn;
		const hideFirstHourLine = isFirst && !isFirstColumn;

		let labelText = '';
		if (isFirst) {
			labelText = '00';
		} else if (isLast) {
			labelText = '00:00';
		} else if (shouldShowLabel) {
			labelText = formatNumberToHours(i);
		}

		hours.push(
			<div
				key={i}
				className={`${styles.hour} ${showFirstLine ? styles.firstLine : ''} ${hideFirstHourLine ? styles.firstHourNoBorder : ''}`}
			>
				{shouldShowLabel && (
					<div
						className={`
							${styles.hourNumber}
							${isFirst ? styles.first : ''}
							${isLast ? styles.last : ''}
						`}
					>
						{labelText}
					</div>
				)}
			</div>
		);
	}
	return <div className={`${styles.timeScale} ${isLastLabel ? styles.lastDay : ''}`}>{hours}</div>;
};

export default TimeScale;
